import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.label,
      item: item.href ? `http://godhands.cn/${item.href}` : undefined,
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <nav aria-label="breadcrumb" className="w-full px-4 md:px-6">
        <ol className="flex items-center gap-2 text-xs text-foreground-500 py-3 flex-wrap">
          {items.map((item, index) => (
            <li key={index} className="flex items-center gap-2">
              {index > 0 && <span className="text-foreground-400">/</span>}
              {item.href ? (
                <Link to={item.href} className="hover:text-primary-500 transition-colors whitespace-nowrap">
                  {item.label}
                </Link>
              ) : (
                <span className="text-foreground-700 whitespace-nowrap">{item.label}</span>
              )}
            </li>
          ))}
        </ol>
      </nav>
    </>
  );
}